import Paper from "@mui/material/Paper";
import {Avatar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography} from "@mui/material";
import moment from "moment";
import Box from "@mui/material/Box";

const ApprovalInformations = ({data}) => {
    return (
        <div className="bid-comparsion-card">
            <TableContainer
                component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow className="bg-grey">
                            <TableCell colspan={6} align="center" sx={{ p: '5px' }}>
                                <Typography variant="h6" sx={{fontWeight: 'bold'}}>
                                    Approvals Information
                                </Typography>
                            </TableCell>
                        </TableRow>


                        <TableRow>
                            <TableCell sx={{ p: '10px' }}>
                                <Typography sx={{fontWeight: 'bold'}} >
                                    Sequence
                                </Typography>
                            </TableCell>
                            <TableCell sx={{ p: '10px' }}>
                                <Typography sx={{fontWeight: 'bold'}}>
                                    Main Information
                                </Typography>
                            </TableCell>
                            <TableCell sx={{ p: '10px' }}>
                                <Typography sx={{fontWeight: 'bold'}}>
                                    Approve Date
                                </Typography>
                            </TableCell>
                            <TableCell sx={{ p: '10px' }}>
                                <Typography sx={{fontWeight: 'bold'}}>
                                    Approve Status
                                </Typography>
                            </TableCell>
                            <TableCell sx={{ p: '10px' }}>
                                <Typography sx={{fontWeight: 'bold'}}>
                                    Signature
                                </Typography>
                            </TableCell>
                            <TableCell sx={{ p: '10px' }}>
                                <Typography sx={{fontWeight: 'bold'}}>
                                    Comment
                                </Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.map(item => (
                            <TableRow key={item?.sequence}>
                                <TableCell>{item?.sequence}</TableCell>
                                <TableCell>
                                    <Box display="flex" alignItems="center" gap={1}>
                                        {item?.userPhoto && (
                                            <Avatar src={item?.userPhoto}/>
                                        )}
                                        <Box display="flex" flexDirection="column" gap={1}>
                                            <Typography fontWeight="bold">
                                                {item?.fullName}
                                            </Typography>
                                            {item?.approveStageDetailsName || item?.description}
                                        </Box>
                                    </Box>
                                </TableCell>
                                <TableCell>{item?.approveDate && moment(item?.approveDate).format('DD.MM.YYYY HH:mm')}</TableCell>
                                <TableCell>{item?.approveStatus}</TableCell>
                                <TableCell>
                                    <img width="80px" src={item?.signaturePhoto} alt={item?.fullName}/>
                                </TableCell>
                                <TableCell>{item?.comment}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}

export default ApprovalInformations
